<script>
  import setWindowHistory from "@utils/window-history";

  export default {
    props: {

    },
    data() {
      return {

      }
    },
    computed: {
      submitData: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
    },
    mounted() {
    },
    destroyed() {

    },
    methods: {
      // test(item) {
      //   this.submitData[item] = ''
      //   console.log(this.$refs[`ref${item}`])
      //   this.$refs.reftype[0].blur()
      // }
    }
  }
</script>
<template>
  <div 
    ref="baseSearchBar" 
    :class="[$style.baseSearchBarBox]">
    <form
      :class="[$style.baseSearchBar,{ isFixed: isMenuFixed }]"
      @submit.prevent="onSubmit"
    >
    </form>
  </div>

</template>
<style lang="scss" module>
  .baseSearchBarBox {
    height: 82px;
    margin-bottom: 6.25rem;

    @include max-lg {
      height: auto;
    }

    @include max-md {
      display: none;
      
    }
    &:global {
      &.isHasBrandMenu {
        .isFixed {
          top: 178px;

          @media screen and (max-width: 1176px) {
            top: 203px;
          }
        }
      }
      &.isShow {
        @include max-md {
          @include var-height(100);
          display: block;
          position: fixed;
          left: 0;
          z-index: 2000;
          padding: 17px 19px 12rem;
          // padding-top: 1rem;
          // padding-right: 15px;
          // padding-bottom: 8rem;
          overflow-y: auto;
          width: 100%;
          top: 0;
          &:before {
            content: '';
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100vh;
            background: hsla(0,0%,100%,.94);
            filter: blur(4px);
            z-index: -1;
          }
        }
      }
    }
  }

  .baseSearchBar {
    position: static;
    top: -300px;
    z-index: 2001;
    transition: .6s;

    &:global {
      &.isFixed {
        position: fixed;
        top: 113px;
        right: 0;
        left: 0;
        z-index: 1501;

        @include max-lg {
          position: static;
        }

        .baseSearchBar {
          &__box {
            background: rgba(255, 255, 255, 0.95);
            box-shadow: 0 2px 4px rgba(33, 69, 88, 16%);
            backdrop-filter: blur(3px);
            @include max-lg {
              box-shadow: none;
              background: transparent;
              backdrop-filter: none;
            }
          }

          &__list {
            width: 100%;
            max-width: 1340px;
            // padding-left: 19px;
            // padding-right: 19px;
            margin: 0 auto;
            border: 0;

          }
        }
      }
    }

    :global {
      .baseSearchBar {
        &__list {
          display: flex;
          align-items: center;
          height: 82px;
          // overflow: hidden;
          background-color: #FFF;
          border: $color-gray-4 1px solid;
          border-right: 0;

          @include max-lg {
            display: block;
            height: auto;
            padding: 1rem 0.5rem;
            overflow: visible;
            background-color: $color-gray-2;
            border: 0;
          }

          @include max-md {
            background: transparent;
            padding: 0;
            display: flex;
            flex-direction: column;
            height: calc(100vh - 160px);
          }
          &__item {
            position: relative;
            flex: 1;

            &:not(:nth-last-child(1)):not(:nth-last-child(2)) {
              &::after {
                position: absolute;
                top: 22px;
                right: 0;
                width: 3px;
                height: 3px;
                content: "";
                background-color: #E2E4E8;
                border-radius: 50%;
                box-shadow: 0 10px 0 0 #E2E4E8, 0 20px 0 0 #E2E4E8, 0 30px 0 0 #E2E4E8;

                @include max-lg {
                  display: none;
                }
              }
              @include max-md {
                border-bottom: 1px solid #E2E4E8;
                padding-bottom: 1.5rem;
              }
            }

            @include max-lg {
              max-width: 100% !important;
              margin-bottom: 1rem;
              // border: 1px solid $color-gray-3;
            }

            @include max-md {
              width: 100%;
              flex: none;
              margin-bottom: 0;
              &__btn {
                margin-top: auto;
                .baseButton {
                  border-radius: 5px;
                }
              }
            }
          }
          
        }
      }
    }
  }
</style>
